((document, Drupal) => {
  "use strict";

  Drupal.behaviors.companyDirectory = {
    attach: function (context) {
      const companyDirectory = context.querySelector(
        ".company-directory"
      );
      if (companyDirectory) {
        const map = context.querySelector(
          ".company-directory__map"
        );
        if (map) {
          const hideMapCta = context.querySelector(
            ".company-directory__cta .cta-hide-map"
          );
          hideMapCta.addEventListener("click", function (event) {
            event.preventDefault();
            if (map.classList.value.includes("is-hide")) {
              map.classList.remove("is-hide");
            } else {
              map.classList.add("is-hide");
            }
          });

          const buildMap = function () {
            const createMarker = function (points, map) {
              const lon = points.split(',')[0];
              const lat = points.split(',')[1];
              if (lon !== "" && lat !== "") {
                const marker = new mapboxgl.Marker()
                  .setLngLat([lon, lat])
                  .addTo(map);
              }
            }

            // // Get geocode points from another view query.
            let companie_points = drupalSettings.companyDirectory.geocodePoints;

            // // Get geocode points from another view query.
            let result_count = drupalSettings.companyDirectory.resultCount;

            let companies_onload = drupalSettings.companyDirectory.onloadGeocodePoints;

            if(!companie_points) {
              companie_points = companies_onload;
            }
            
            if( result_count !== 0 ) {
              
              // // Get geocode from first index.
              let centerPoint = companie_points[0];

              centerPoint = [centerPoint.split(',')[0], centerPoint.split(',')[1]];

              mapboxgl.accessToken = 'pk.eyJ1IjoiZ21hcnRpbmV6LWNlbnRyZXRlayIsImEiOiJjbDFuemY0ODEwMHB4M2NueHF5cmp1cnhiIn0.rAEFpNPES1QUaG5LNoHOIw';
              const mapElement = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/mapbox/streets-v11',
                center: centerPoint,
                zoom: 8
              });
              for (let i = 0; i < companie_points.length; i++) {
                const points = companie_points[i];
                createMarker(points, mapElement);
              }
            }
          }
          buildMap();
        }

        const resetCta = context.querySelector(
          ".company-directory__cta .cta-reset-filters"
        );

        if (resetCta) {
          resetCta.addEventListener("click", function (event) {

            const resetFormButton = context.querySelector('[data-drupal-selector="edit-reset"]');

            if(resetFormButton !== null) {
              resetFormButton.click();
            }
            
          });
        }

        const categorySelector = context.querySelector('select[name="field_company_category_target_id"]');
        const buyerSelector = context.querySelector('select[name="field_company_buyer_target_id"]');
        const settingSelector = context.querySelector('select[name="field_company_setting_target_id"]');
        const userSelector = context.querySelector('select[name="field_company_user_target_id"]');
        const activitiesSelector = context.querySelector('select[name="field_company_activities_target_id"]');
        const typeSelector = context.querySelector('select[name="field_company_type_target_id"]');

        if(categorySelector) {
          categorySelector.addEventListener('change', function (event) {
            const labelSelected = Drupal.t(event.srcElement.selectedOptions[0].text).toLowerCase().replaceAll(' ', '_');
            if (labelSelected == 'digital_health_company') {
              buyerSelector.parentElement.classList.add('show');
              settingSelector.parentElement.classList.add('show');
              userSelector.parentElement.classList.add('show');
            } else {
              buyerSelector.parentElement.classList.remove('show');
              settingSelector.parentElement.classList.remove('show');
              userSelector.parentElement.classList.remove('show');
            }
  
            if (labelSelected == 'investor') {
              activitiesSelector.parentElement.classList.add('show');
            } else {
              activitiesSelector.parentElement.classList.remove('show');
            }
  
            if (labelSelected == 'startup_support') {
              typeSelector.parentElement.classList.add('show');
            } else {
              typeSelector.parentElement.classList.remove('show');
            }
          });
        }

      }
    },
  };
})(document, Drupal);
